import React, { Component } from 'react';
import { Example, Properties, SourceCode, Tip } from 'examples';
import Breadcrumbs from './Breadcrumbs';

class BreadcrumbsExample extends Component {

  state = {
    path: [{
      id: 1,
      title: 'Root',
      test: true,
    }, {
      id: 2,
      title: 'Level 1',
      contentType: 'page',
    }, {
      id: 3,
      title: 'Level 2',
      contentType: 'lock',
    }],
  };

  onChange = e => this.setState(e.target.value);

  onClick = e => window.showAppInfo(e.target.value.title);

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={Breadcrumbs.defaultProps} propTypes={Breadcrumbs.propTypes} propValues={this.state}>
          <Tip>You can long press the Back button to display the entire navigation path.</Tip>
          <Tip>Try setting <em>highlightedIconName</em> and <em>highlightedType</em> to <span className="string">lock</span></Tip>
        </Properties>
        <Breadcrumbs {...this.state} onClick={this.onClick}/>
        <SourceCode querySelector=".breadcrumbs-example .core-breadcrumbs"/>
      </Example>
    );
  }

}

BreadcrumbsExample.tags = 'navigation';

export default BreadcrumbsExample;
